import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const FileWidget = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      fontSize='inherit'
      viewBox='0 0 10 11'
    >
      <path
        d='M2 9V0H6.5L9.5 3V9H2ZM6 3.5V1H3V8H8.5V3.5H6ZM0 11V3H1V10H6.5V11H0Z'
        fill='currentColor'
      />
    </SvgIcon>
  );
};

export default FileWidget;
